module.exports = __webpack_public_path__ + "static/img/img_gunyu_women_banner.cd8e8301.png";